<template>
    <form class="flex flex-col pt-3 md:pt-8" :class="theme" @submit.prevent="handleSubmit">
        <div class="flex flex-col pt-4" data-cy="forgot_password_email">
            <ui-label for="email">
                {{ $t('auth.form.fields.email') }}
            </ui-label>
            <ui-input
                v-model="v$.forgot_password.email.$model"
                id="email"
                :class="{ 'form-error': v$.forgot_password.email.$error }"
            />
            <p class="text-help">{{ $t('auth.form.help.email') }}</p>
            <div
                :class="{ 'text-default-red': v$.forgot_password.email.$error }"
                data-cy="forgot_password_email-error"
                v-if="v$.forgot_password.email.required.$invalid && v$.forgot_password.email.$error"
            >
                {{ $t('validation.required') }}
            </div>
            <div
                :class="{ 'text-default-red': v$.forgot_password.email.$error }"
                data-cy="forgot_password_email-email-error"
                v-if="
                    v$.forgot_password.email.email.$invalid &&
                    v$.forgot_password.email.$error &&
                    !v$.forgot_password.email.required.$invalid
                "
            >
                {{ $t('validation.email', { attribute: 'Email Address' }) }}
            </div>
            <validation-errors :errors="validation.errors.email" v-if="validation.errors" data-cy="form-error-list" />
        </div>

        <p class="text-default-red text-center pt-4" data-cy="form-error-messages" v-if="validation.message">
            {{ validation.message }}
        </p>

        <ui-submit-button data-cy="forgot_password_button" class="auth-button" :disabled="processing">
            <span v-if="!processing">
                {{ $t('auth.form.buttons.forgot') }}
            </span>
            <span v-else>
                {{ $t('auth.form.buttons.forgotting') }}
            </span>
        </ui-submit-button>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';
import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInput,
        UiLabel,
        UiSubmitButton,
        ValidationErrors,
    },
    validations: {
        forgot_password: {
            email: {
                required,
                email,
            },
        },
    },
    props: ['forgot_password', 'validation', 'processing', 'theme'],
    methods: {
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('formSubmit');
        },
    },
};
</script>
